<template>
    <DataTable default-to-primera :headers="headers" :path="path" :properties="properties" :filterPath="filterPath" filter ref="datatable">
        <span slot="after-filters">
          <v-tooltip bottom>
            <v-btn slot="activator" icon @click="downloadExcel" flat>
              <v-icon color="primary">far fa-file-excel</v-icon>
            </v-btn>
            <span>Descargar XLS</span>
          </v-tooltip>
        </span>
    </DataTable>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import { paginationMixin } from '../../../mixins/paginationMixin'

export default {
  mixins: [downloadFileMixin, paginationMixin],

  components: {
    DataTable
  },

  data () {
    return {

      headers: [
        { text: 'Desde Apertura', value: 'fromDate', sortable: false, align: 'left', dateFilterField: true, visible: false },
        { text: 'Hasta Apertura', value: 'toDate', sortable: false, align: 'left', dateFilterField: true, visible: false },
        { text: 'Fecha de apertura', value: 'openingDate', sortable: false, align: 'left' },
        { text: 'Club', value: 'club', sortable: false, align: 'left', filterField: true },
        { text: 'Departamento', value: 'department', sortable: false, align: 'left', filterField: true },
        { text: 'Estado', value: 'status', sortable: false, align: 'left', filterField: true },
        { text: 'Última notificación', value: 'modified', sortable: false, align: 'left' }
      ],
      properties: ['openingDate', 'club', 'departamento', 'estado', 'modified'],
      path: 'consultas/list',
      filterPath: 'filters/inquiries'
    }
  },

  methods: {
    getExcelPath () {
      return 'consultas/xls' + '?' + this.$refs.datatable.getFilteringPath().substring(1)
    },
    getFilenamePrefix () {
      return 'consultas'
    }
  }
}
</script>

<style scoped>

</style>
